module.exports = __webpack_public_path__ + "static/CircularStd-Bold-1ced22ee6d45bdd05a5383fd9dbd1b43.woff";